import { create } from "zustand";
import { URL } from "../../lib/apis";

interface CartState {
  transProposal: any | null; // Initialise à null pour éviter les erreurs au chargement
  loadingDetail: boolean;
  fetchtransProposal: (quotId: string, propoId: string) => Promise<void>;
}

const usetransProposal = create<CartState>((set) => ({
  transProposal: null, // Initialise à null avant le chargement des données
  loadingDetail: false,

  fetchtransProposal: async (quotId: string, propoId: string) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user");

    if (!token) {
      console.error("User is not authenticated");
      return;
    }

    set({ loadingDetail: true });

    try {
      const response = await fetch(
        `${URL}/quotation/${quotId}/proposal/${propoId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch categories: ${response.statusText}`);
      }

      const data = await response.json();
      set({ transProposal: data.data, loadingDetail: false }); // On assigne directement 'data' sans 'data.data'
    } catch (error) {
      if (error instanceof Error) {
        console.error("Error fetching categories:", error.message);
      } else {
        console.error("Unknown error occurred");
      }
      set({ loadingDetail: false });
    }
  },
}));

export default usetransProposal;
